import React, { Component } from "react"
import { Segment } from "semantic-ui-react"
import "./Devis.css"

import CoordonnéesDevis from "./CoordonnéesDevis"
import DescriptionDevis from "./DevisComp/DescriptionDevis.jsx"
import ConditionDevis from "./ConditionDevis"

export default class Devis extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Segment id="ficheDevis">
        <CoordonnéesDevis />
        <DescriptionDevis />
        <ConditionDevis />
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/Devis.js